import { SimpleMapper } from "./SimpleMapper";
import { UpdateUserDTO } from "../domain/models/dto/UpdateUserDTO";
import UserModel from "../models/UserModel";
import { FileMapper } from "./FileMapper";

export class UpdateUserMapper extends SimpleMapper<UserModel, UpdateUserDTO> {
    protected toDTOFields: string[] = [
        "id",
        "firstName",
        "lastName",
        "middleName",
        "phone",
        "position",
        "description",
        "files",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "creatorId",
        "createdAt",
        "updatedAt",
    ];
    protected entityConstructor = UserModel;
    private fileMapper = new FileMapper();
    toDTO(model: UserModel): UpdateUserDTO {
        if (!model) {
            return null;
        }

        const baseDto = super.toDTO(model);
         baseDto.files =
            model.files?.map((file) => this.fileMapper.toDTO(file)) ?? [];
        return baseDto;
    }

    fromDTO(dto: UpdateUserDTO): UserModel {
        if (!dto) {
            return null;
        }
        const baseModel = super.fromDTO(dto);
        baseModel.files =
            dto.files?.map((file) => this.fileMapper.fromDTO(file)) ?? [];
        return baseModel;
    }
}
